.dropzone {
  width: 100%!important;
  height: 100%!important;
  background: transparent!important;
  border: none!important;
}
